/**
 * Mirrors `Field.prototype.isValid`'s numeric check in `packages/core/src/core/field.js`
 * (used by the legacy "add item" form) so the "numeric text" custom field type validates
 * identically whether an item is being created or an existing one is being edited.
 */
export const isValidNumericText = (value: string): boolean => {
	return !isNaN(parseFloat(value)) && isFinite(Number(value));
};
